import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { images } from '../mockData';

const BeforeAfterSection = () => {
  const { t } = useLanguage();
  const position1 = 50;
  const position2 = 50;
  const position3 = 50;

  const beforeAfterData = [
    {
      before: images.beforeAfter[0].before,
      after: images.beforeAfter[0].after,
      category: t.beforeAfter.categories[0]
    },
    {
      before: images.beforeAfter[1].before,
      after: images.beforeAfter[1].after,
      category: t.beforeAfter.categories[1]
    }
  ];

  return (
    <section id="before-after" className="pad-2xl" style={{ background: 'var(--bg-section)' }}>
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="heading-2 mb-4">{t.beforeAfter.title}</h2>
          <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
            {t.beforeAfter.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {beforeAfterData.map((item, idx) => (
            <div key={idx} className="product-card">
              <div className="grid grid-cols-2 gap-2 mb-4">
                <div className="relative rounded-lg overflow-hidden aspect-square">
                  <img
                    src={item.before}
                    alt={t.beforeAfter.before}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute bottom-2 left-2 bg-gray-700 text-white px-2 py-1 rounded text-xs font-semibold">
                    {t.beforeAfter.before}
                  </div>
                </div>
                <div className="relative rounded-lg overflow-hidden aspect-square">
                  <img
                    src={item.after}
                    alt={t.beforeAfter.after}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute bottom-2 right-2 bg-blue-400 text-white px-2 py-1 rounded text-xs font-semibold">
                    {t.beforeAfter.after}
                  </div>
                </div>
              </div>
              <p className="font-semibold text-center" style={{ color: 'var(--text-primary)' }}>
                {item.category}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => {
              const el = document.getElementById('booking');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="btn-primary"
          >
            {t.language === 'en' ? 'Book Your Cleaning Now' : 'Κλείστε τον Καθαρισμό σας Τώρα'}
          </button>
        </div>
      </div>
    </section>
  );
};

export default BeforeAfterSection;
